import {
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationCircle,
  FaQuestionCircle,
  FaCircle,
} from "react-icons/fa";
import {} from "react-icons/md";
import { TbCircuitSwitchClosed, TbCircuitSwitchOpen } from "react-icons/tb";
import Badge from "widgets/shared/badge";

export const deviceStatusIcon = (
  battery: number | null,
  signal: number | null,
  valve?: string | null,
  lastComms?: string | null,
  userCredit?: number | null,
  contacterState?: string | null
) => {
  const userCreditIcon =
    userCredit === null ? null : (
      <Badge label={`${userCredit} kWh`} color="cyan" />
    );

  const batteryIcon =
    battery === null ? null : battery > 3 ? (
      <Badge label={`${battery} V`} color="green" />
    ) : battery > 1 ? (
      <Badge label={`${battery} V`} color="yellow" />
    ) : (
      <Badge label={`${battery} V`} color="red" />
    );

  const signalIcon =
    signal === null ? null : signal >= -125 ? (
      <Badge label={`${"GOOD"}`} color="green" />
    ) : signal < -125 && signal >= -135 ? (
      <Badge label={`${"AVERAGE"}`} color="yellow" />
    ) : (
      <Badge label={`${"WEAK"}`} color="red" />
    );

  const lastCommsIcon = (() => {
    if (!lastComms) return null;
    const lastCommsDate = new Date(lastComms);
    if (isNaN(lastCommsDate.getTime())) return null;

    const minutesAgo = (Date.now() - lastCommsDate.getTime()) / 60000;
    if (minutesAgo > 30) {
      return <Badge label="OFFLINE" color="red" />;
    }
    return <Badge label="ONLINE" color="green" />;
  })();

  const valveIcon =
    valve === null ? null : valve === "OPEN" ? (
      <div
        className={`flex items-center justify-center rounded-md border-green-500 bg-green-100 px-2 py-1 text-sm font-bold uppercase text-green-700`}
      >
        <TbCircuitSwitchOpen size={20} />
      </div>
    ) : (
      <div
        className={`flex items-center justify-center rounded-md border-red-500 bg-red-100 px-2 py-1 text-sm font-bold uppercase text-red-700`}
      >
        <TbCircuitSwitchOpen size={20} />
      </div>
    );

  const contacterIcon =
    contacterState === null ? null : contacterState === "OPEN" ? (
      <div
        className={`flex items-center justify-center rounded-md border-red-500 bg-red-100 px-2 py-1 text-sm font-bold uppercase text-red-700`}
      >
        <TbCircuitSwitchOpen size={20} />
      </div>
    ) : (
      <div
        className={`flex items-center justify-center rounded-md border-green-500 bg-green-100 px-2 py-1 text-sm font-bold uppercase text-green-700`}
      >
        <TbCircuitSwitchClosed size={20} />
      </div>
    );

  return {
    batteryIcon,
    signalIcon,
    valveIcon,
    lastCommsIcon,
    userCreditIcon,
    contacterIcon,
  };
};

export const deviceVerifiedIcon = (dataQuality: string | null) => {
  const verifiedIcon =
    dataQuality === null ? null : dataQuality === "VERIFIED" ? (
      <FaCheckCircle className="text-green-500" />
    ) : dataQuality === "UNVERIFIED" ? (
      <FaTimesCircle className="text-yellow-500" />
    ) : dataQuality === "ERROR" ? (
      <FaExclamationCircle className="text-red-500" />
    ) : dataQuality === "QUERIED" ? (
      <FaQuestionCircle className="text-blue-500" />
    ) : (
      <FaCircle className="text-gray-500" />
    );

  return { verifiedIcon };
};

export const JobStatusIcon = (status: string | null) => {
  const statusIcon =
    status === null ? null : status === "COMPLETED" ? (
      <FaCheckCircle className="text-green-500" />
    ) : status === "PENDING" ? (
      <FaTimesCircle className="text-yellow-500" />
    ) : status === "FAILED" ? (
      <FaExclamationCircle className="text-red-500" />
    ) : (
      <FaCircle className="text-gray-500" />
    );

  return { statusIcon };
};
